import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { MessageProvider } from "./contexts/MessageContext";

const root = createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <MessageProvider>
      <App />
    </MessageProvider>
  </React.StrictMode>
);
